import { createGlobalStyle } from 'styled-components';

export const LockBodyScroll = createGlobalStyle`
  html, body {
    overflow: hidden;
  }
`;
